;(function () {
  'use strict'

  angular.module('contrast.highcharts').constant('HIGHCHARTS_Z_INDEX', {
    BOTTOM: 1,
    MIDDLE: 3,
    TOP: 5
  })
})()
